<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" class="pt-0" TRANSACTIONS>
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card flat :loading="loading">
                  <v-card-text class="py-0 pt-0">
                    <v-row>
                      <v-col cols="12" v-if="product && !loading">
                        <v-row>
                          <v-col cols="12" md="4" class="text-center" IMAGE>
                              <v-row IMAGE DIV>
                                <v-col cols="12" class="pa-0">
                                  <v-card flat outlined >
                                    <v-row IMAGE DIV>
                                      <v-col cols="12" class="pa-4 py-0 pt-2 ma-0">
                                        <div style="text-align:center;cursor:pointer;">
                                          <img
                                            v-if="product.featured_image && product.featured_image.url"
                                            :src="active_image.url"
                                            style="max-width:100%;max-height:380px;"
                                          >
                                          
                                        </div>
                                      </v-col>
                                      <v-col cols="12" class="px-4 py-0 ma-0" v-if="product.media">
                                        <v-row>
                                          <v-col cols="3" v-for="(image, m) in product.media.filter(x=>x.type==='image')" :key="'image'+m">
                                            <img width="100%" :src="image.url" alt="" style="cursor:pointer;" @click="()=>{
                                              active_image = image
                                            }">
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" class="pa-4 py-0 pt-2 ma-0">
                                        <v-btn color="success" block large outlined :class="`${arabic?'arFont':'enFont'}`" @click="downLoadAll(product.id)">
                                          {{ i18n['download_all_photos_videos_to_your_pc'] }}
                                          <v-icon right>download</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-col>
                              </v-row>
                          </v-col>
                          <v-col cols="12" md="8" PRDUCT-DETAILS>
                            <v-row class="pa-2">
                              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" NAME-CAT>
                                <v-row :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pb-2`">
                                    {{ i18n['product_name'] }}
                                  </v-col>
                                </v-row>
                                <div 
                                  :class="`${arabic?'arFont':'enFont'} secondary--text pt-3`" 
                                  style="font-size:24px;">
                                  {{ product['title_'+language].trim() }}
                                </div>
                                <div 
                                  :class="`${arabic?'arFont':'enFont'} pt-2 pb-3`" 
                                  style="font-size:11px;">
                                  {{ product.title_en.trim() }}
                                  <v-btn 
                                    v-clipboard:copy="product.title_en"
                                    color="success" 
                                    x-small 
                                    icon>
                                    <v-icon size="10">content_copy</v-icon>
                                  </v-btn>
                                </div>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  <v-chip label x-small :class="`${arabic?'arFont':'enFont'}`">
                                    {{ i18n['product_code'] }}
                                  </v-chip>
                                  <span class="success--text px-2">{{product.sku}}</span>
                                </div>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`" v-if="product.country && product.country.name">
                                  <v-chip label x-small :class="`${arabic?'arFont':'enFont'}`">
                                    {{ i18n['origin'] }}
                                  </v-chip>
                                  <span class="success--text px-2">{{product.country.name}}</span>
                                </div>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" PRICE-SECTION>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  {{ i18n["product_price"] }}
                                </div>
                                <v-row class="pa-1">
                                  <v-col cols="6" md="3" v-for="(price, p) in product.prices" :key="'price-'+p" class="">
                                    <img :src="`/flags/${price.country.alpha2Code.toLowerCase()}.png`" height="40px" />
                                    <div style="font-weight:bold;">{{countryTranslation[price.country.alpha2Code.toLowerCase()]}}</div>
                                    <div style="font-size:12px;">{{i18n["price"]}}</div>
                                    <div class="primary--text" style="font-size:15px;font-weight:bold;">${{price.formatted_price}}</div>
                                    <div style="font-size:12px;">{{i18n["suggested_sale_price"]}}</div>
                                    <div class="primary--text" style="font-size:15px;font-weight:bold;">${{price.formatted_suggested_sale_price}}</div>
                                    <div style="font-size:12px;">{{i18n["min_order_quantity"]}}</div>
                                    <div class="primary--text" style="font-size:15px;font-weight:bold;">{{price.min_order_quantity}} {{i18n["pieces"]}}</div>
                                    <div style="font-size:12px;">{{i18n["time_to_warehouse"]}}</div>
                                    <div class="primary--text" style="font-size:15px;font-weight:bold;">{{price.time_to_warehouse}} {{i18n["day"]}}</div>
                                    <div class="mt-2">
                                      <v-btn color="success" :disabled="!create_po" small @click="newPurchaseOrder(price)">{{ i18n["start_a_new_purchaseOrder"] }}</v-btn>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                                <Calculator v-if="product.prices" :prices="product.prices" :fees="fees" />
                              </v-col>
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:20px;" DIVIDER>
                                <v-divider></v-divider>
                              </v-col>
                              
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'} `" VIDEO-AND-DESCRIPTION>
                                <v-tabs
                                  v-model="tab"
                                >
                                  <v-tabs-slider></v-tabs-slider>
                                  <v-tab href="#tab-1" :class="`${arabic?'arFont':'enFont'} `">
                                    {{ i18n['product_description'] }}
                                  </v-tab>
                                  <v-tab href="#tab-2" :class="`${arabic?'arFont':'enFont'} `">
                                    {{ i18n['product_video'] }}
                                  </v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="tab">
                                  <v-tab-item
                                    :value="'tab-1'"
                                  >
                                    <v-card flat>
                                      <v-card-text v-html="product['description_' + language]" ></v-card-text>
                                    </v-card>
                                  </v-tab-item>
                                  <v-tab-item
                                    :value="'tab-2'"
                                  >
                                    <v-card flat>
                                      <v-card-text>
                                        <v-row>
                                          <v-col cols="12" v-for="(video, v) in product.media.filter(x=>x.type==='video')" :key="'video-'+v">
                                            <video :src="video.url" width="100%" controls></video>
                                          </v-col>
                                          <v-col cols="12" class="pa-4 py-0 pt-2 ma-0">
                                            <v-btn color="success" block large outlined :class="`${arabic?'arFont':'enFont'}`" @click="downLoadAll(product.id)">
                                              {{ i18n['download_all_photos_videos_to_your_pc'] }}
                                              <v-icon right>download</v-icon>
                                            </v-btn>
                                          </v-col>
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-col>
                              
                            </v-row>
                            <PlacePurchaseOrder :dialog="dialog" :po="po" @close="cancelPlaceOrder" @confirm="confirmPurchaseOrder" />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-2`" v-if="related.length">
                        <div style="font-size:15px;font-weight:bold;">{{i18n['related_products']}}</div>
                      </v-col>
                      <v-col cols="12" class=" py-2">
                        <v-row>
                          <v-col cols="12" md="3" v-for="(item, index) in related" :key="'itemrelated-'+ index">
                            <Product :item="item" :loading="loading" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppImg from '@/components/imgPlaceholder';
import productSlider from '@/components/productSlider';
import ImagesSlider from '@/components/ImagesSlider';
import PlacePurchaseOrder from './PlacePurchaseOrderDialog';
import Calculator from './Calculator';
import Product from './Product';

export default {
    components:{ AppImg, ImagesSlider, productSlider, PlacePurchaseOrder, Calculator, Product },
  data(){
    return {
      loading:false,
      product:{},
      countries:[],
      tags:[],
      active_image:null,
      tab:'tab-1',
      dialog:false,
      po:{},
      fees:[],
      related:[],
      create_po:true,
    }
  },
  methods:{
    async downLoadAll(id) {
      this.loading = true
      window.open(`https://yervip.com/api/v1/download-wholesale/${id}`, '_blank').focus();
      this.loading = false
    },
    cancelPlaceOrder(){
      this.dialog = false

    },
    async newPurchaseOrder(s){
      this.po = {
        quantity:s.min_order_quantity,
        note:null,
        settings_id:s.id,
        product_id:this.product.id,
        min_order_quantity: s.min_order_quantity
      }
      this.dialog = true
    },
    async confirmPurchaseOrder(){
        const posData = await this.$store.dispatch('postResource', { resource: `/purchase-wholesale`, value:{...this.po} })
        if(posData.success) {
			    this.$router.push(`/purchase-order/${posData.purchase_order_id}/details`)
        } else {
          this.$emit('snackbarNotification', posData.message, 'error')
        }
    },
    async init(){
      this.loading = true
      if(this.$route.params.page) {
        const posData = await this.$store.dispatch('getResource', { resource: `/wholesale-products/${this.$route.params.page}` })
        this.create_po = posData.create_po
        this.product = posData.product
        this.active_image = posData.product.media.filter(x=>x.type==='image')[0]
        this.countries = posData.countries.map(x=>{return {...x, text:this.countryTranslation[x.alpha2Code.toLowerCase()]}})
        this.tags = posData.tags.map(x=>{return{...x, text:`${x.en} | ${x.ar}`}})
        this.fees = posData.fees
        this.related = posData.relatedProducts
      }
      this.loading = false
    }
  },
  watch:{
    async $route (to, from){
      await this.init()

    },
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
    countryTranslation(){
      return this.$store.state.countries_[this.language];

    }
  },
  async created(){
    await this.init()
  }
}
</script>

<style>

</style>